import { useTranslation } from '@frontend/i18n';
import type { GetWeavePopNotificationByType } from '@frontend/types';
import { BaseNotificationComponentProps, BaseNotificationInner, BaseNotificationOuter } from './base';
import { DefaultNotificationBody } from './defaults/default-notification';

type Props = BaseNotificationComponentProps<GetWeavePopNotificationByType<'device-connection'>>;

export const DeviceConnectionNotification = ({ isHistorical, emit, notification, ...rest }: Props) => {
  const { t } = useTranslation('phoneSync');

  return (
    <BaseNotificationOuter actions={[]} notification={notification} emit={emit} isHistorical={isHistorical} {...rest}>
      <BaseNotificationInner
        onClose={() => emit({ action: 'ignore', payload: undefined }, notification)}
        actions={[]}
        title={t('Device Connection Changed')}
        body={
          <DefaultNotificationBody
            name={notification.payload.deviceName || t('Unknown Device')}
            body={t('Your connection to {{deviceName}} has been taken over by {{activeUserName}}', {
              deviceName: notification.payload.deviceName || t('Unknown Device'),
              activeUserName: notification.payload.activeUserName || t('a different user'),
            })}
          />
        }
        location={notification.location}
        timestamp={notification.timestamp}
        id={notification.id}
        notificationType={notification.type}
        {...rest}
      />
    </BaseNotificationOuter>
  );
};
